module.exports = __webpack_public_path__ + "static/img/zengzhi.8e528b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/zengzhi.jpg
// module id = ICTB
// module chunks = 1